import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { QuoteViewerService } from "src/app/core/services/quote-viewer.service";
import { PaymentProcessingRate } from "src/app/shared/models/DTO/quote-viewer.dto";

@Component({
	selector: "app-quote-payment-processing-rates",
	templateUrl: "./quote-payment-processing-rates.component.html",
	styleUrls: ["./../quote-viewer.scss"],
})
export class QuotePaymentProcessingRatesComponent implements OnInit {
	constructor(public app: AppService, public quoteService: QuoteViewerService) {}

	ngOnInit(): void {
		this.quoteService.quote.subscribe((data) => {
			if (data.Payment_Processing_Rate__r) {
				this.buildRates(data.Payment_Processing_Rate__r);
			}
		});
	}

	buildRates(rates: PaymentProcessingRate) {
		rates.VMCD_Bin_Rate__c = rates.VMCD_Bin_Rate__c / 100;
		rates.AMEX_Bin_Rate__c = rates.AMEX_Bin_Rate__c / 100;
	}
}
